/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CircleAdmin = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 88 88">
      <path
        d="M44.1 70C59.7849 70 72.5 58.046 72.5 43.3C72.5 28.554 59.7849 16.6 44.1 16.6C28.4151 16.6 15.7 28.554 15.7 43.3C15.7 58.046 28.4151 70 44.1 70Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.9 45.9C56.1 45.1 56.1 44.3 56.1 43.5C56.1 42.7 56 41.9 55.9 41.1V41L59 38L56.1 33L51.9 34.1C50.7 33.1 49.3 32.3 47.8 31.7H47.7L46.5 27.5H40.7L39.5 31.7H39.4C37.9 32.2 36.5 33 35.3 34.1H35.2L31 32.9L28.1 37.9L31.2 41V41.1C31 41.9 31 42.7 31 43.5C31 44.3 31.1 45.1 31.2 45.9V46L28.1 49.1L31 54.1L35.2 53H35.3C36.5 54 37.9 54.8 39.4 55.4H39.5L40.6 59.6H46.4L47.5 55.4H47.6C49.1 54.9 50.5 54.1 51.7 53L55.9 54.1L58.8 49.1L55.9 45.9ZM48.7 45.1C47.8 45.1 47.1 44.4 47.1 43.5C47.1 41.6 45.5 40 43.6 40C41.7 40 40 41.6 40 43.5C40 45.4 41.6 47 43.5 47C44.4 47 45.1 47.7 45.1 48.6C45.1 49.5 44.4 50.2 43.5 50.2C39.8 50.2 36.8 47.2 36.8 43.5C36.8 39.8 39.8 36.8 43.5 36.8C47.2 36.8 50.2 39.8 50.2 43.5C50.2 44.4 49.5 45.1 48.7 45.1Z"
        fill="#21295C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.5 0C19.5 0 0 19.5 0 43.5C0 67.5 19.5 87 43.5 87C67.5 87 87 67.5 87 43.5C87 19.5 67.6 0 43.5 0ZM59.3 43.5C59.3 43.9 59.3 44.4 59.2 44.8L61.2 46.9C62.2 47.9 62.4 49.4 61.7 50.5L58.7 55.7C58.2 56.6 57.2 57.2 56.1 57.2C55.8 57.2 55.6 57.2 55.3 57.1L52.5 56.3C51.8 56.8 51 57.3 50.2 57.6L49.4 60.4C49.1 61.7 47.9 62.6 46.5 62.6H40.5C39.1 62.6 38 61.7 37.6 60.4L36.8 57.6C36 57.2 35.2 56.8 34.5 56.3L31.7 57.1C31.4 57.2 31.2 57.2 30.9 57.2C29.8 57.2 28.8 56.6 28.3 55.7L25.3 50.5C24.6 49.3 24.8 47.8 25.8 46.9L27.8 44.8C27.8 44.3 27.7 43.9 27.7 43.5C27.7 43.1 27.7 42.6 27.8 42.2L25.8 40.1C24.8 39.1 24.7 37.6 25.3 36.5L28.3 31.3C28.8 30.4 29.8 29.8 30.9 29.8C31.2 29.8 31.4 29.8 31.7 29.9L34.5 30.7C35.2 30.2 36 29.7 36.8 29.4L37.6 26.6C38 25.3 39.2 24.4 40.5 24.4H46.5C47.9 24.4 49 25.3 49.4 26.6L50.2 29.4C51 29.8 51.8 30.2 52.5 30.7L55.3 29.9C55.5 29.8 55.8 29.8 56.1 29.8C57.2 29.8 58.2 30.4 58.7 31.3L61.7 36.5C62.4 37.7 62.2 39.2 61.2 40.1L59.1 42.2C59.3 42.7 59.3 43.1 59.3 43.5Z"
        fill="#21295C"
      />
    </BaseSvgIcon>
  )
}

export default CircleAdmin
